import { RootState } from '@next/core-lib/app';
import { EntityState } from '@ngrx/entity';

export interface TailBitingModuleState extends RootState {
  tailBitings?: TailBiting[];
  selectedTailBiting?: TailBiting;
  selectedCountry?: string;
  isLoaded: boolean;
}

export type TailBitingState = EntityState<TailBiting>;

export interface TailBitingsResponse {
  tailBitings: TailBiting[];
}
export interface UpsertTailBitingResponse {
  id: number;
  isOffline?: boolean;
}
export interface TailBitingDataSource {
  id: number;
  name: string;
  date: string;
  createdBy: string;
  numberOfPens: number;
  location: string;
  locationId: number;
  ages: string;
}

export interface TailBiting {
  id: number;
  name: string;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
  customerId: number;
  locationId: number;
  date: string;
  pigType: pigType;
  tailDocking: boolean;
  pens: Pen[];
}

export interface Pen {
  age: number;
  tailLength: TailLengthType;
  tailPosition?: TailPosition;
  tailDamage: TailDamageType;
  freshness?: FreshnessType;
}

export enum pigType {
  FATTENING = 'Fattening',
  WEANED_PIGLETS = 'WeanedPiglet',
}

export enum TailLengthType {
  FULL = 'Full',
  PARTIALLYSHORTEND = 'PartiallyShortend',
  SHORT = 'Short',
}

export enum TailPosition {
  UP = 'Up',
  RELAXED = 'Relaxed',
  PRESSESBETWEENLEGS = 'PressesBetweenLegs',
}

export enum TailDamageType {
  NODAMAGE = 'NoDamage',
  BITEMARKS = 'BiteMarks',
  WOUND = 'Wound',
  INFLAMEDWOUND = 'InflamedWound',
}

export enum FreshnessType {
  DAMAGE = 'Damage',
  REDSCAB = 'RedScab',
  DARKBLOOD = 'DarkBlood',
  FRESHBLOOD = 'FreshBlood',
}

export interface LocationItem {
  value: number;
  name: string;
  selected: boolean;
}
